import React from 'react';
import styles from './RegionalFreePeriodBanner.module.scss';

const RegionalFreePeriodLookupError = () => (
    <section className={`${styles.banner} ${styles.error}`} role="alert">
        <span className={styles.errorIcon} aria-hidden="true">!</span>
        <div>
            <p className={styles.title}>Placement fee temporarily unavailable</p>
            <p className={styles.message}>
                We could not confirm this shift's regional pricing. Try again before posting; TempStars will not silently charge an unconfirmed campaign fee.
            </p>
        </div>
    </section>
);

export default RegionalFreePeriodLookupError;
